var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"optimized-image-container"},[(_vm.imagePath)?_c('img',{class:_vm.combinedClasses,style:([_vm.imageOpacityStyle, { 
      width: '100%', 
      height: '100%', 
      objectFit: 'cover', 
      objectPosition: 'center',
      position: 'absolute',
      top: 0,
      left: 0
    }]),attrs:{"src":_vm.imagePath,"fetchpriority":_vm.priority,"loading":_vm.loadingStrategy,"alt":_vm.altText},on:{"load":_vm.handleImageLoaded,"error":_vm.handleImageError}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }